var _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXcBai(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 200,
    fill: "#FFF846"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3674 154.165C46.2669 150.065 46.2669 143.417 50.3674 139.316C54.4679 135.216 61.1161 135.216 65.2166 139.316L98.6274 172.727C102.728 176.827 102.728 183.476 98.6274 187.576C94.5269 191.677 87.8786 191.677 83.7781 187.576L50.3674 154.165Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.901 224.699C116.801 220.599 116.801 213.95 120.901 209.85C125.002 205.749 131.65 205.749 135.75 209.85L169.161 243.261C173.262 247.361 173.262 254.009 169.161 258.11C165.061 262.21 158.412 262.21 154.312 258.11L120.901 224.699Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.312 139.316C158.412 135.216 165.061 135.216 169.161 139.316C173.262 143.417 173.262 150.065 169.161 154.165L135.75 187.576C131.65 191.677 125.002 191.677 120.901 187.576C116.801 183.476 116.801 176.827 120.901 172.727L154.312 139.316Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7781 209.85C87.8786 205.749 94.5269 205.749 98.6274 209.85C102.728 213.95 102.728 220.599 98.6274 224.699L65.2166 258.11C61.1161 262.21 54.4679 262.21 50.3674 258.11C46.2669 254.009 46.2669 247.361 50.3674 243.261L83.7781 209.85Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.986 318.676V78.75H268.578C292.114 79.2429 339.188 91.7629 339.188 137.9C339.188 171.461 321.527 182.211 313.001 187.401L312.94 187.438C333.273 193.738 363.439 225.072 349.539 270.617C336.564 313.131 289.28 318.676 276.711 318.676H187.986ZM284.824 152.69C284.824 168.615 271.914 181.525 255.988 181.525C240.063 181.525 227.153 168.615 227.153 152.69C227.153 136.764 240.063 123.854 255.988 123.854C271.914 123.854 284.824 136.764 284.824 152.69ZM290.716 248.084C290.716 267.276 275.158 282.834 255.966 282.834C236.774 282.834 221.215 267.276 221.215 248.084C221.215 228.892 236.774 213.333 255.966 213.333C275.158 213.333 290.716 228.892 290.716 248.084Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXcBai);
export default __webpack_public_path__ + "static/media/xc-bai.7dc5ae2a3765c8b442e83c0cb96f6a36.svg";
export { ForwardRef as ReactComponent };